module.exports = __webpack_public_path__ + "img/d2x.ad2803be.png";